/** Langues pour lesquelles l'interface apprenant a des traductions i18n. */
export const SUPPORTED_UI_LANGUAGES = ['fr', 'en', 'pt'] as const;
export type SupportedUiLanguage = (typeof SUPPORTED_UI_LANGUAGES)[number];

export const DEFAULT_LOGIN_UI_LANGUAGES: SupportedUiLanguage[] = ['fr', 'en', 'pt'];

export const DEFAULT_LOGIN_PICKER_LANGUAGES = ['fr', 'en', 'pt'] as const;

export const normalizeLangCode = (lang?: string | null): string =>
  (lang || '').toLowerCase().split('-')[0].trim();

export const isSupportedUiLanguage = (lang: string): lang is SupportedUiLanguage =>
  (SUPPORTED_UI_LANGUAGES as readonly string[]).includes(lang);

/** Langue d'affichage UI : langue supportée ou en en repli. */
export const resolveInterfaceLanguage = (lang?: string | null): SupportedUiLanguage => {
  const normalized = normalizeLangCode(lang);
  if (isSupportedUiLanguage(normalized)) {
    return normalized;
  }
  return 'en';
};

export const normalizeLanguageList = (languages: string[] | undefined | null): string[] => {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const lang of languages || []) {
    const normalized = normalizeLangCode(lang);
    if (!normalized || seen.has(normalized)) continue;
    seen.add(normalized);
    result.push(normalized);
  }
  return result;
};

export const pickInitialFormationLanguage = (
  preferred: string | undefined,
  availableLanguages: string[],
  defaultLanguage: string
): string => {
  const available = normalizeLanguageList(availableLanguages);
  if (available.length === 0) return normalizeLangCode(defaultLanguage) || 'en';

  const preferredNorm = normalizeLangCode(preferred);
  if (preferredNorm && available.includes(preferredNorm)) {
    return preferredNorm;
  }

  const defaultNorm = normalizeLangCode(defaultLanguage);
  if (defaultNorm && available.includes(defaultNorm)) {
    return defaultNorm;
  }

  return available[0];
};
